
import { useState, useEffect } from 'react';
import { supabase } from "@/integrations/supabase/client";

export const useMarginData = () => {
  const [pricePerUnit, setPricePerUnit] = useState(0);
  const [discountRate, setDiscountRate] = useState(0);
  const [costPerUnit, setCostPerUnit] = useState(0);
  const [orderVolume, setOrderVolume] = useState(0);

  const fetchInitialData = async () => {
    try {
      const { data, error } = await supabase.from('margin_analysis').select('*');
      if (error) {
        console.error('Error fetching margin analysis data:', error);
        return;
      }
      if (data && data.length > 0) {
        const pricePerUnitRecord = data.find(item => item.category === 'Price Per Unit');
        const discountRateRecord = data.find(item => item.category === 'Discount Rate');
        const costPerUnitRecord = data.find(item => item.category === 'Cost Per Unit');
        const orderVolumeRecord = data.find(item => item.category === 'Order Volume');
        if (pricePerUnitRecord && pricePerUnitRecord.value !== null) setPricePerUnit(Number(pricePerUnitRecord.value));
        if (discountRateRecord && discountRateRecord.value !== null) setDiscountRate(Number(discountRateRecord.value));
        if (costPerUnitRecord && costPerUnitRecord.value !== null) setCostPerUnit(Number(costPerUnitRecord.value));
        if (orderVolumeRecord && orderVolumeRecord.value !== null) setOrderVolume(Number(orderVolumeRecord.value));
      }
    } catch (error) {
      console.error('Error in fetchInitialData:', error);
    }
  };

  useEffect(() => {
    fetchInitialData();
  }, []);

  return {
    pricePerUnit,
    setPricePerUnit,
    discountRate,
    setDiscountRate,
    costPerUnit,
    setCostPerUnit,
    orderVolume,
    setOrderVolume,
    fetchInitialData
  };
};
